/**
 * Static dropdown data for policy forms
 * Migrated from Firebase to reduce Firestore reads
 * Version: 2025-10-21-v1
 */

export const DROPDOWN_VERSION = "2025-10-21-v1";

// Insurance Companies by Category
export const COMPANIES = {
  motor: [
    "HDFC ERGO",
    "New India Assurance",
    "ICICI Lombard",
    "Bajaj Allianz",
    "Tata AIG",
    "Reliance General",
    "SBI General",
    "United India",
    "Oriental",
    "National",
    "IFFCO Tokio General",
    "Kotak Mahindra General",
    "Future Generali India",
    "Bharti AXA General",
    "Cholamandalam MS General",
    "Liberty General",
    "Edelweiss General",
    "Shriram General",
    "Magma HDI General",
    "Go Digit",
    "Royal Sundaram General",
    "ACKO General",
    "Zuno General",
    "Navi"
  ],
  life: [
    "LIC",
    "HDFC Life",
    "ICICI Prudential",
    "SBI Life",
    "Max Life",
    "Bajaj Allianz Life",
    "Tata AIA Life",
    "Aditya Birla Sun Life",
    "PNB MetLife",
    "Kotak Life",
    "Canara HSBC Life",
    "Edelweiss Tokio",
    "IndiaFirst Life",
    "Star Union Dai-ichi"
  ],
  non_motor: [
    "HDFC ERGO",
    "ICICI Lombard",
    "Bajaj Allianz",
    "Tata AIG",
    "Reliance General",
    "SBI General",
    "Digit Insurance",
    "Acko Insurance",
    "Kotak General",
    "Iffco Tokio",
    "Future Generali",
    "Royal Sundaram",
    "Universal Sompo",
    "New India Assurance",
    "United India Insurance",
    "Oriental",
    "National Insurance",
    "Star Health and Allied Insurance",
    "Liberty General Insurance",
    "Navi Insurance"
  ]
};

// Vehicle Makes by Type
export const VEHICLE_MAKES = {
  two_wheeler: [
    "Honda",
    "Suzuki",
    "Yamaha",
    "KTM",
    "Royal Enfield",
    "TVS",
    "Hero MotoCorp",
    "Bajaj",
    "Ather",
    "Ola Electric",
    "Harley Davidson",
    "Ducati",
    "Triumph",
    "Aprilia",
    "Kawasaki",
    "BMW Motorrad",
    "HERO HONDA",
    "Mahindra",
    "Kinetic",
    "Vespa",
    "Ampere",
    "Piaggio",
    "JAWA",
    "EIDER"
  ],
  four_wheeler: [
    "Maruti Suzuki",
    "Tata",
    "Mahindra",
    "Hyundai",
    "Kia",
    "Toyota",
    "Renault",
    "MG",
    "Nissan",
    "Skoda",
    "Volkswagen",
    "Citroen",
    "Chevrolet",
    "Ford",
    "Mercedes-Benz",
    "Audi",
    "BMW",
    "Jeep",
    "Volvo",
    "Land Rover",
    "Jaguar",
    "Porsche",
    "Lexus",
    "Bajaj",
    "Honda",
    "Fiat",
    "Hindustan",
    "Datsun",
    "Piaggio"
  ],
  commercial_vehicle: [
    "Ashok Leyland",
    "Tata",
    "Piaggio",
    "Mahindra",
    "BharatBenz",
    "Eicher swaraj",
    "Force Motors",
    "SML Isuzu",
    "AMW",
    "Volvo Trucks",
    "Scania",
    "MAN",
    "Atul Auto",
    "Tvs",
    "Bajaj",
    "Maruti Suzuki",
    "Toyota",
    "Hyundai",
    "Honda",
    "JCB"
  ]
};

// Policy Types by Category
export const POLICY_TYPES = {
  motor: [
    "Liability",
    "Own Damage",
    "Package"
  ],
  life: [
    "Term Insurance",
    "Endowment Policy",
    "Whole Life Policy",
    "Child Plan",
    "Group Life Insurance"
  ],
  health: [
    "Health Companion",
    "Individual Health Policy",
    "Family Floater Policy",
    "Personal Accident Insurance",
    "Group Mediclaim",
    "Senior Citizen Health Plan",
    "Burglary", "Fire & Safety",
    "House Holders Insurance"
  ]
};

// Helper function to get companies by category
export const getCompaniesByCategory = (category) => {
  switch (category) {
    case "motor":
      return COMPANIES.motor;
    case "life":
      return COMPANIES.life;
    case "health":
    case "non-motor":
      return COMPANIES.non_motor;
    default:
      return [];
  }
};

// Helper function to get vehicle makes by type
export const getVehicleMakesByType = (vehicleType) => {
  switch (vehicleType) {
    case "Two Wheeler":
      return VEHICLE_MAKES.two_wheeler;
    case "Private Vehicle":
      return VEHICLE_MAKES.four_wheeler;
    case "Commercial Vehicle":
      return VEHICLE_MAKES.commercial_vehicle;
    default:
      return [];
  }
};

// Helper function to get policy types by category
export const getPolicyTypesByCategory = (category) => {
  switch (category) {
    case "motor":
      return POLICY_TYPES.motor;
    case "life":
      return POLICY_TYPES.life;
    case "health":
    case "non-motor":
      return POLICY_TYPES.health;
    default:
      return [];
  }
};
